/**
 * FramedSurface — the design's "framed · detail to follow" treatment for the domains
 * whose full build is a follow-on stage (Order Book, Delivery & Quality, Governance,
 * Intelligence). Kicker + title + description, a hero chart, and the domain's notes.
 * Deliberately honest that detail follows — never a fake-complete screen.
 */

import React from 'react'
import SurfaceHeader from '../components/kit/SurfaceHeader'

export interface Note {
  h: string
  p: string
}
export interface FramedConfig {
  kicker: string
  kickerColor?: string
  title: string
  desc: string
  chartTitle: string
  chart: React.ReactNode
  notes: Note[]
}

export default function FramedSurface({ kicker, kickerColor, title, desc, chartTitle, chart, notes }: FramedConfig): React.JSX.Element {
  return (
    <div className="cx-fade cx-page py-6 pb-20 space-y-4">
      <SurfaceHeader kicker={kicker} kickerColor={kickerColor} title={title} desc={desc} />
      <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-dashed border-line font-mono text-[10.5px] tracking-[.08em] uppercase text-mut2">
        framed · detail to follow
      </div>
      <div className="border border-line rounded-xl bg-panel overflow-hidden">
        <div className="px-4 py-3 border-b border-line2 font-semibold text-[13.5px] text-ink">{chartTitle}</div>
        <div className="px-3 py-4">{chart}</div>
      </div>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(230px,1fr))] gap-3">
        {notes.map((n, i) => (
          <div key={i} className="border border-line rounded-xl px-4 py-3.5 bg-panel">
            <div className="font-semibold text-[13.5px] text-ink mb-1">{n.h}</div>
            <div className="text-[12.5px] text-mut leading-[1.55]">{n.p}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
